import React from 'react';
import './FenceSearchBar.scss';

interface FenceSearchBarProps {
  filter: string;
  onFilterChange: (value: string) => void;
  placeholder?: string;
  wantedItems?: 'fence' | 'tag';
  resultsCount?: number;
}

const FenceSearchBar: React.FC<FenceSearchBarProps> = ({
  filter,
  onFilterChange,
  placeholder = "Search fences...",
  wantedItems = 'fence',
  resultsCount
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onFilterChange(e.target.value);
  };

  const clearSearch = () => {
    onFilterChange('');
  };

  return (
    <div className="FenceSearchBar">
      <div className="FenceSearchBar-InputWrapper">
        <input
          type="text"
          id="fence-search-input"
          name="fence-search-input"
          placeholder={placeholder}
          value={filter}
          onChange={handleChange}
          className="FenceSearchBar-Input"
        />

        {filter && (
          <button
            className="FenceSearchBar-ClearButton"
            onClick={clearSearch}
            title="Clear search"
          >
            ×
          </button>
        )}
      </div>

      {filter && resultsCount !== undefined && (
        <div className="FenceSearchBar-ResultsInfo">
          Found {resultsCount} {wantedItems}{resultsCount !== 1 ? 's' : ''}
        </div>
      )}
    </div>
  );
};

export default FenceSearchBar;